import * as React from 'react';
import styles from './select-options.scss';

export interface SelectOptionsProps {
  showLongDescriptions?: boolean;
  children?: React.ReactNode;
}

export class SelectOptions extends React.PureComponent<SelectOptionsProps, any> {
  public render() {
    return <ul className={`grid-200 ${this.props.showLongDescriptions ? styles.fullWidthOptions : ''}`}>
      {this.props.children}
    </ul>;
  }
}
